/**
 * Sort Order Constants
 * 정렬 기준 상수
 *
 * 프로젝트 전체에서 사용되는 정렬 기준을 중앙에서 관리합니다.
 * 하드코딩된 정렬 문자열을 제거하고 일관성을 유지합니다.
 */

/**
 * 정렬 방향
 */
export const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
} as const;

/**
 * 정렬 필드
 */
export const SORT_FIELD = {
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  OCCURRED_AT: 'occurredAt',
  APPOINTMENT_DATE: 'appointmentDate',
  NAME: 'name',
  PHONE: 'phone',
  ID: 'id',
} as const;

/**
 * 일반적으로 사용되는 정렬 기준 (Spring Data 형식: field,direction)
 */
export const SORT_ORDER = {
  /**
   * 상담 이력 정렬 (발생 시간 내림차순)
   */
  CONSULT: `${SORT_FIELD.OCCURRED_AT},${SORT_DIRECTION.DESC}`,

  /**
   * 예약 이력 정렬 (예약 날짜 내림차순)
   */
  APPOINTMENT: `${SORT_FIELD.APPOINTMENT_DATE},${SORT_DIRECTION.DESC}`,

  /**
   * 생성일 내림차순 (최신순)
   */
  CREATED_DESC: `${SORT_FIELD.CREATED_AT},${SORT_DIRECTION.DESC}`,

  /**
   * 생성일 오름차순 (오래된순)
   */
  CREATED_ASC: `${SORT_FIELD.CREATED_AT},${SORT_DIRECTION.ASC}`,

  /**
   * 수정일 내림차순
   */
  UPDATED_DESC: `${SORT_FIELD.UPDATED_AT},${SORT_DIRECTION.DESC}`,

  /**
   * 이름 오름차순 (가나다순)
   */
  NAME_ASC: `${SORT_FIELD.NAME},${SORT_DIRECTION.ASC}`,

  /**
   * ID 내림차순
   */
  ID_DESC: `${SORT_FIELD.ID},${SORT_DIRECTION.DESC}`,
} as const;

/**
 * 정렬 문자열 생성 헬퍼 함수
 * @param field 정렬 필드
 * @param direction 정렬 방향 (기본값: desc)
 * @returns Spring Data 형식의 정렬 문자열 (예: 'createdAt,desc')
 */
export const createSortString = (
  field: string,
  direction: 'asc' | 'desc' = SORT_DIRECTION.DESC
): string => {
  return `${field},${direction}`;
};

/**
 * 정렬 타입
 */
export type SortOrder = typeof SORT_ORDER[keyof typeof SORT_ORDER];
